// Lib
import * as Immutable from 'immutable';
import { EditorState } from 'draft-js';

export default (state, action) =>
    EditorState.set(state, {
        undoStack: Immutable.Stack(),
        redoStack: Immutable.Stack(),
    });
